module.exports = __webpack_public_path__ + "src/assets/img/earbuds_02.4ef0f8db.png";